import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { IIncomingActivities } from '../../../models/components/lesson-incoming-activities';
import { Common } from '../../../core/common';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions/coursePage';
import Loading from '../../loading/loading';
import Moment from 'moment';
import ProgressCircle from '../../progress-circle/progress-circle';
import { withRouter, Link } from 'react-router-dom';
import ContentLoader from 'react-content-loader';
const T = Translator.create();
const _logger = Log.create('complated-activities.tsx');
const token: any = localStorage.getItem('access_token');
let _common: Common;

function stringToHash(str: string): string {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString();
}

class InComingActivities extends React.Component<IIncomingActivities> {

    constructor(props: any) {
        super(props);
        Moment.locale(T.i18next.language);
        _common = new Common();
    }

    public componentDidMount = () => {
        if (this.props.coursePageClassId) {
            this.props.dispatch(Actions.getCoursePageIncomingActivities(this.props.coursePageClassId, 'getCoursePageIncomingActivities', 'get'));
        }
    }

    public componentWillReceiveProps = (nextProps: IIncomingActivities) => {
        if (nextProps.coursePageClassId !== this.props.coursePageClassId) {
            if (nextProps.coursePageClassId) {
                nextProps.dispatch(Actions.getCoursePageIncomingActivities(nextProps.coursePageClassId));
            }
        }
    }

    public compareDate = (dueDate: any) => {
        return (new Date(dueDate)).getTime() > Date.now() ? 'green' : 'red';
    }

    public diffDate = (dueDate: any) => {
        const dueDateMoment = Moment(dueDate);
        const nowMoment = Moment(Date.now());

        if (nowMoment < dueDateMoment) {
            const diff = Moment.duration(dueDateMoment.diff(nowMoment));
            if (diff.days() > 15) return dueDateMoment.valueOf;

            if (diff.days()) return diff.days() + ' Gün Sonra';
            if (diff.minutes()) return diff.minutes() + ' Dakika Sonra';
            if (diff.seconds()) return diff.seconds() + ' Saniye Geçmiş';
        }

        if (nowMoment > dueDateMoment) {
            const diff = Moment.duration(nowMoment.diff(dueDateMoment));
            if (diff.days() > 15) return dueDateMoment.valueOf;

            if (diff.days()) return diff.days() + ' Gün Geçmiş';
            if (diff.minutes()) return diff.minutes() + ' Dakika Geçmiş';
            if (diff.seconds()) return diff.seconds() + ' Saniye Geçmiş';
        }

    }

    public percentageDate: number | any = (dueDateStr: any) => {
        const max = 7 * 24;
        const dueDate = new Date(dueDateStr);
        if (Date.now() > dueDate.getTime()) {
            // passed activities
            const diff = (Date.now() - dueDate.getTime()) / (3600 * 1000); // hours
            return diff >= max ? 100 : Math.round(diff * 100 / max);
        } else {
            // incoming activities
            const diff = (dueDate.getTime() - Date.now()) / (3600 * 1000); // hours
            return diff >= max ? 0 : (100 - Math.round(diff * 100 / max));
        }
    }

    getActivity = (activity: any, termWeeks?: any) => {
        let termWeekId = activity.termWeekId;

        if (termWeeks && termWeeks.length > 0) {
            const isInTermWeek = termWeeks
                .filter((termWeek: any) => termWeek.startDate && (Moment(termWeek.startDate).toDate() < Moment(activity.activityBeginDate).toDate()) &&
                    termWeek.endDate && (Moment(termWeek.endDate).toDate() > Moment(activity.activityBeginDate).toDate()));
            termWeekId = isInTermWeek && isInTermWeek.length > 0 ? isInTermWeek[0].termWeekId : '';
        }

        // this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, true, 'getCourseContentMenu', 'get'));
        // this.props.dispatch(
        //     Actions.getCourseContentsActivityCardAction(
        //         1,
        //         this.props.coursePageClassId!,
        //         this.props.coursePageActivityId!,
        //         activity.activityId,
        //         termWeekId,
        //         200,
        //         0,
        //         'spinnerIdWeekA',
        //         'get'
        //     )
        // );
        const url =
            window.appSettings.DEFAULT_URL +
            '/u/course?classId=' +
            this.props.coursePageClassId +
            '&activityId=' +
            this.props.coursePageActivityId +
            '&type=1&actid=' +
            activity.activityId +
            '&weekorunitid=' +
            termWeekId;
        this.props.history.push(url);
    }

    onClickActivity = (activity: any) => {
        // if(!activity.termWeekId && activity.activityBeginDate && activity.activityEndDate) {
        //     this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, false, 'getCourseContentMenu', 'get',
        //         (termWeeks: any) => {
        //             this.getActivity(activity, termWeeks);
        //         }
        //     ));
        // } else {
        this.getActivity(activity);
        //}
    };

    public render() {
        const loadingSpaces = 74;
        return (
            <div className="upcomming-events mt-3 animated fadeIn white-box shadow p-3" >
                <span className='lms-header-medium' tabIndex={0}>
                    <Link to={window.appSettings.DEFAULT_URL + '/u/activities-dashboard?completed=1&classId=' + this.props.coursePageClassId}>
                        {T.t('r_course_page_upcoming_activities')}
                        <span className="count" style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>
                            {(this.props.incomingActivities) ?
                                this.props.incomingActivities.filter(act => act.activityName).length : 0}
                        </span>
                    </Link>
                </span>
                <div>
                    <Loading spinnerId={'getCoursePageIncomingActivities'}>
                        <div style={{ backgroundColor: '#eeede9' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 350 200"
                                style={{ width: '100%' }}
                            >
                                <circle cx="36" cy="64" r="30" />
                                <rect x="85" y="42" rx="0" ry="0" width="200" height="15" />
                                <rect x="85" y="68" rx="0" ry="0" width="200" height="15" />

                                <circle cx="36" cy={loadingSpaces + 64} r="30" />
                                <rect x="85" y={loadingSpaces + 42} rx="0" ry="0" width="200" height="15" />
                                <rect x="85" y={loadingSpaces + 68} rx="0" ry="0" width="200" height="15" />

                            </ContentLoader>
                        </div>
                    </Loading>
                    <div id="getCoursePageIncomingActivities_Content" className='py-3 px-2 mt-2'>{
                        (this.props.incomingActivities && this.props.incomingActivities.filter(act => act.activityName).length > 0) ?
                            (
                                <div className='d-flex flex-column gap-2'>
                                    {(this.props.incomingActivities.filter(act => act.activityName).slice(0, 5).map((activity, index) =>
                                        <div key={activity.activityName ? stringToHash(activity.activityName) : index}   className="points d-flex mt-0">
                                            <ProgressCircle
                                                imageSrc={_common.GetMaterialActivityIcons(activity.activityType!)}
                                                imageAlt="clock"
                                                color={this.compareDate(activity.dueDate)}
                                                percent={this.percentageDate(activity.dueDate)}
                                            />
                                            <div>
                                                <a style={{ color: 'black' }} onClick={this.onClickActivity.bind(this, activity)} tabIndex={0}> <h6 className="onHoverActivitiesStyle">{(activity.activityName) ? activity.activityName : T.t('r_activity_name_cannot_reached')}</h6></a>
                                                <span>{T.t('r_delivery_date')}:</span>
                                                <span tabIndex={0} className={this.compareDate(activity.dueDate) === 'green' ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'}> {(activity.dueDate) ? ' ' + Moment(activity.dueDate).locale(T.i18next.language).fromNow() : ''} </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <span tabIndex={0}>{T.t('r_notfound_upcoming_activity')}</span>
                            )
                    }</div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IIncomingActivities): IIncomingActivities => {
    if (!state) {
        return ownProps;
    }
    const newProps: IIncomingActivities = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        incomingActivities: state.coursePage.incomingActivities,
        incomingActivitiesIsLoaded: state.coursePage.incomingActivitiesIsLoaded,
        coursePageActivityId: state.coursePage.coursePageActivityId,
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.incomingActivities === prev.coursePage.incomingActivities
    );
    return ret;
};

const CInComingActivities = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(InComingActivities);

export default withRouter(CInComingActivities);
